module.exports = __webpack_public_path__ + "img/1539060665.45717c7b.jpg";